export type RichTextLimitVariant = "default" | "email";

function isEmptyRichText(html: string): boolean {
  const normalized = html
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, "")
    .toLowerCase();
  return (
    !normalized ||
    normalized === "<p></p>" ||
    normalized === "<p><br></p>" ||
    normalized === "<p><br/></p>"
  );
}

/** Plain-text length for the user-facing counter. Block tags become newlines. */
export function getPlainTextLength(html: string): number {
  if (!html || isEmptyRichText(html)) {
    return 0;
  }

  let text: string;
  if (typeof document !== "undefined") {
    const withBreaks = html
      .replace(/<\/(p|div|h[1-6]|li|tr|blockquote)>/gi, "\n")
      .replace(/<br\s*\/?>/gi, "\n");
    const doc = new DOMParser().parseFromString(withBreaks, "text/html");
    text = doc.body.textContent || "";
  } else {
    text = html
      .replace(/<\/(p|div|h[1-6]|li|tr|blockquote)>/gi, "\n")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<[^>]*>/g, "");
  }

  return text.replace(/\n+$/g, "").length;
}

/** Raw HTML length for the server @MaxLength check. Empty shells count as 0. */
export function getHtmlLength(html: string): number {
  if (!html || isEmptyRichText(html)) {
    return 0;
  }
  return html.length;
}

export function checkRichTextLength(
  html: string,
  max: number
): {
  plainLength: number;
  htmlLength: number;
  isOver: boolean;
} {
  const plainLength = getPlainTextLength(html);
  const htmlLength = getHtmlLength(html);
  return {
    plainLength,
    htmlLength,
    isOver: htmlLength > max,
  };
}

export function getRichTextLimitError(
  html: string,
  max: number,
  variant: RichTextLimitVariant = "default"
): string | null {
  const { htmlLength, isOver } = checkRichTextLength(html, max);
  if (!isOver) {
    return null;
  }

  if (variant === "email") {
    return `When saved, this is converted to an email template. With that conversion included it is ${htmlLength} characters, which exceeds the ${max} character limit. Remove some formatting or text.`;
  }

  return `This content is ${htmlLength} characters once formatting is included, which exceeds the ${max} character limit. Remove some formatting or text.`;
}
